// extracted by mini-css-extract-plugin
module.exports = {"heading":"NoResults_heading__zN7AE","didYouMean":"NoResults_didYouMean__gQ_hv","searchTips":"NoResults_searchTips__hprB8"};